import { incomePlan, dateAtAge, ageLabel, birthYearOf } from "@/lib/fers";
import { scanRetirementDates } from "@/lib/retireDate";

const DAY = 864e5;
const iso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
const r2 = (v) => Math.round((Number(v) || 0) * 100) / 100;
export const toDate = (s) => new Date(`${s}T00:00:00`);
export const daysUntil = (s, now = new Date()) => Math.max(0, Math.ceil((toDate(s) - now) / DAY));

export function retirementDay(p) {
  return dateAtAge(p, Number(p.retire_age)) || new Date(birthYearOf(p) + Number(p.retire_age), 11, 31);
}

function nextMilestone(p) {
  const today = new Date();
  const m = scanRetirementDates(p).milestones.map((x) => ({ label: x.label, when: x.exact || x.row.date })).filter((x) => x.when > today).sort((a, b) => a.when - b.when)[0];
  return m ? { label: m.label.slice(0, 120), date: iso(m.when) } : null;
}

export function buildSnapshot(p, totals = {}) {
  const plan = incomePlan(p, totals);
  const { pen, ss } = plan;
  const first = plan.rows[0] || {};
  const fullAge = Math.max(Number(p.retire_age), pen.eligible ? pen.startAge : 0, ss.claimAge);
  const full = plan.rows.find((r) => r.age >= fullAge) || first;
  return {
    retirement_date: iso(retirementDay(p)), exact_date: !!p.birth_date, retire_age: Number(p.retire_age), system: p.retirement_system || "",
    plan_label: (pen.type || "").slice(0, 120),
    pension_monthly: r2(pen.eligible ? pen.annual / 12 : 0), pension_start_age: r2(pen.startAge),
    supplement_monthly: r2(pen.supplement / 12), ss_monthly: r2(ss.annualAtClaim / 12), ss_claim_age: r2(ss.claimAge),
    withdrawal_monthly: r2((first.withdrawal || 0) / 12), first_year_monthly: r2((first.gross || 0) / 12),
    full_monthly: r2((full.gross || 0) / 12), full_age: r2(fullAge), tsp_balance: r2(totals.tsp), next_milestone: nextMilestone(p),
  };
}

export function incomeLines(d) {
  return [
    { key: "pension", label: "Pension", value: d.pension_monthly, note: d.pension_monthly ? `Starts at age ${ageLabel(d.pension_start_age)}` : "No pension in this plan" },
    ...(d.supplement_monthly > 0 ? [{ key: "supplement", label: "FERS Supplement", value: d.supplement_monthly, note: "Paid until age 62" }] : []),
    { key: "ss", label: "Social Security", value: d.ss_monthly, note: `Claiming at age ${ageLabel(d.ss_claim_age)}` },
    { key: "withdrawals", label: "TSP / IRA withdrawals", value: d.withdrawal_monthly, note: "First year of retirement" },
  ];
}
